// extracted by mini-css-extract-plugin
export default {"container":"editable-data_container__xeBiQ","textarea":"editable-data_textarea__qZ-eC","buttons":"editable-data_buttons__37Hpy"};